module.exports = __webpack_public_path__ + "static/img/James-Worpel.4dffb1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/James-Worpel.jpg
// module id = wRio
// module chunks = 0